import React, { useState } from "react";
import TextLanguage from "../../../data/TextLanguage.json";
import {
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    Menu,
    MenuItem
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { fileUploader } from "../../../functions/fileUploader";
import { useUploadExcelFilteredList } from "../../../hooks/useUploadExcelFilteredList";
import CloseIcon from '@mui/icons-material/Close';

export const FilterListUploadButton = ({
    lang,
    setsnackbarStatus,
    setUploadProgress,
    LDMFilteredPatientList,
    setLDMFilteredPatientList
}) => {


    const uploadExcelFilteredListMutation = useUploadExcelFilteredList({ setsnackbarStatus, setUploadProgress, setLDMFilteredPatientList });

    const handleFilteredListUnload = (event) => { setLDMFilteredPatientList([]); }



    return (<>


        {LDMFilteredPatientList.length > 0 ? <Button sx={{
            borderRadius: '0px',
            padding: '10px 15px',
            maxHeight: '45px', width: 'auto',

        }}
            onClick={handleFilteredListUnload}
        >
            <div style={{ display: 'flex', gap: '0.5rem,' }}>
                {`Excel - LDM (${LDMFilteredPatientList.length})`}
                <CloseIcon sx={{ color: 'red' }} />
            </div>
        </Button>
            :
            <Button sx={{
                borderRadius: '0px',
                padding: '10px 15px',
                maxHeight: '45px', width: 'auto',

            }}
                onClick={fileUploader(uploadExcelFilteredListMutation, '.xls,.xlsx', { filter: JSON.stringify([0, 0, 1, 0]) })}
            >
                {`EXCEL - LDM`}
            </Button>}



    </>);
}
